<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" width="620" v-model="dialog" scrollable persistent>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        {{ isEdit ? 'CẬP NHẬP KỲ NGHỈ' : 'THÊM MỚI KỲ NGHỈ' }}
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="cancel" class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            class="required mt-8"
            :rules="[(v) => !!v || 'Vui lòng nhập tên kỳ nghỉ']"
            v-model="name"
            label="Tên kỳ nghỉ"
            outlined
            dense
          />
          <v-row>
            <v-col cols="6">
              <DateIOSPicker
                class="required"
                :date.sync="startDate"
                :rules="[$rules.required, $rules.date]"
                @update:date="handleDateChange"
                label="Từ ngày"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <DateIOSPicker
                class="required"
                :date.sync="endDate"
                :rules="[$rules.required, $rules.date]"
                @update:date="handleDateChange"
                label="Đến ngày"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
        <div
          v-if="!getClassLoading && affectedClasses && affectedClasses.length > 0"
          class="mt-6 red--text"
        >
          (*) Các lớp
          <span v-for="(cls, index) in affectedClasses.slice(0, 5)" :key="index">
            <router-link style="text-decoration: none; white-space: nowrap" :to="'/class/' + cls.classId" target="_blank">
              {{ cls.classInfo.title }}{{ index !== affectedClasses.slice(0, 5).length - 1 ? ', ' : '' }}
            </router-link>
          </span>
          <span v-if="affectedClasses.length > 5" class="red--text">và {{ affectedClasses.length - 5 }} lớp khác</span>
          có lịch học sẽ bị ảnh hưởng. Vui lòng chú ý.
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="isLoading" depressed class="ma-2" color="primary" medium @click="save" :disabled="isLoading">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay
      v-model="isProgress"
      class="justify-center align-center"
    >
      <div class="d-flex flex-column justify-center align-center">
        <v-progress-circular :rotate="270" :size="120" :width="10" :value="progressPer" color="#FFFFFF">
          <span class="text-h5">{{ `${progressPer}% ` }}</span>
        </v-progress-circular>
        <span class="mt-2">Đang cập nhập lại lịch học...</span>
      </div>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'

export default {
  components: {
    DateIOSPicker,
  },
  data() {
    return {
      dialog: false,
      loading: 0,
      isEdit: false,
      isProgress: false,
      progressPer: '0',
      interval: 0,
      status: null,
      id: null,
      name: '',
      startDate: '',
      endDate: '',
    }
  },
  props: {
    state: Boolean,
  },
  computed: {
    ...mapState('role', ['roles']),
    ...mapState('holiday', ['affectedClasses', 'getClassLoading']),
    isLoading() {
      return this.loading > 0
    },
  },
  methods: {
    ...mapActions('holiday', ['createHoliday', 'updateHoliday', 'getAffectedClasses', 'fetchHoliday']),
    openDialog(data) {
      this.dialog = true
      this.isEdit = true
      this.status = data.status
      this.id = String(data.id)
      this.name = data.name
      this.startDate = data.startDate
      this.endDate = data.endDate
    },
    validateStartAndEndDate() {
      const startDate = moment(this.startDate)
      const today = moment().startOf('day')
      if (today.isAfter(startDate)) {
        const mess = 'Ngày bắt đầu không được trong quá khứ'
        this.$alert.error(mess)
        return false
      }
      if (startDate.isAfter(this.endDate)) {
        const mess = 'Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu'
        this.$alert.error(mess)
        return false
      }
      return true
    },
    async save() {
      if (this.$refs.form.validate()) {
        const isValid = this.validateStartAndEndDate()
        if (!isValid) {
          return
        }

        this.$loading.active = true
        try {
          const data = {
            name: this.name,
            startDate: moment(this.startDate).format('YYYY-MM-DD'),
            endDate: moment(this.endDate).format('YYYY-MM-DD'),
          }

          let obj
          if (this.isEdit) {
            obj = await this.updateHoliday({ data, id: this.id })
          } else {
            obj = await this.createHoliday(data)
          }

          this.isProgress = true
          this.interval = setInterval(async () => {
            const holiday = await this.fetchHoliday(obj.id)
            this.progressPer = holiday.progress
            if (holiday.status !== 'running') {
              clearInterval(this.interval)
              this.isProgress = false
              this.dialog = false
              this.reset()
              this.$refs.form.resetValidation()
              this.$emit('done')
            }
          }, 1500)
        } catch (error) {
          this.$alert.addError(error)
        } finally {
          this.$loading.active = false
        }
      }
    },
    cancel() {
      this.dialog = false
      this.isEdit = false
      this.reset()
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    reset() {
      this.name = ''
      this.startDate = ''
      this.endDate = ''
      this.status = null
    },
    handleDateChange() {
      if (this.startDate && this.endDate) {
        this.getAffectedClasses({
          startDate: moment(this.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.endDate).format('YYYY-MM-DD'),
        })
      }
    },
  },
  watch: {
    state() {
      this.dialog = true
      this.reset()
    },
  },
}
</script>
